import React from "react";
import NotFound from "@/pages/NotFound";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";

/**
 * Route gate for `/verified-documents` and `/zh/verified-documents`.
 *
 * Reads `verified_docs_enabled` from `FeatureFlagsContext`. Fails
 * closed on every intermediate state (loading, errored, missing,
 * malformed, unreachable — all collapse into `verified_docs_enabled =
 * false` at the hook layer, except `loading` which this component
 * handles explicitly to avoid a NotFound → real-page flash).
 *
 * - loading           -> render nothing (brief blank, no leak)
 * - flag === false    -> <NotFound />
 * - flag === true     -> children
 */
export function VerifiedDocsGate({ children }) {
  const flags = useFeatureFlags();
  if (flags.loading) {
    return null;
  }
  if (!flags.verified_docs_enabled) {
    return <NotFound />;
  }
  return children;
}

export default VerifiedDocsGate;
